"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonMegaMenu = void 0;
const React = require("react");
const react_1 = require("react");
const megamenu_dropdown_1 = require("./megamenu-dropdown");
const megamenu_link_1 = require("./megamenu-link");
const megamenu_class_nav_enum_1 = require("./megamenu-class-nav.enum");
const megamenu_levels_enum_1 = require("./megamenu-levels.enum");
const constants_1 = require("../../utils/constants");
const BronsonMegaMenu = (props) => {
    const navRef = (0, react_1.useRef)(null);
    const initialOpenState = {
        one: false,
        two: false,
        three: false,
    };
    const [classNav, setClassNav] = React.useState(megamenu_class_nav_enum_1.ClassNav.FIRST);
    const [currentId, setCurrentId] = React.useState('0');
    const [openSubMenu, setOpenSubMenu] = React.useState(initialOpenState);
    React.useEffect(() => {
        setClassNav(megamenu_class_nav_enum_1.ClassNav.FIRST);
        setCurrentId('');
        setOpenSubMenu(initialOpenState);
    }, [props.disabled]);
    const onOpenSubMenu = (level, id, list) => {
        openParentMenu(level, id);
        setMinHeight(level, id, list);
        switch (level) {
            case megamenu_levels_enum_1.Levels.ONE:
                if (id && currentId.indexOf(id) === constants_1.zero && openSubMenu.two) {
                    setOpenSubMenu({
                        one: !openSubMenu.one,
                        two: false,
                        three: false,
                    });
                }
                else {
                    setOpenSubMenu({
                        one: true,
                        two: true,
                        three: false,
                    });
                }
                break;
            case megamenu_levels_enum_1.Levels.TWO:
                if (currentId === id && openSubMenu.three) {
                    setOpenSubMenu({
                        one: !openSubMenu.one,
                        two: true,
                        three: false,
                    });
                }
                else {
                    setOpenSubMenu({
                        one: !openSubMenu.one,
                        two: true,
                        three: true,
                    });
                }
                break;
            default:
                return '';
        }
        if (id) {
            setCurrentId(id);
        }
    };
    const openParentMenu = (level, id) => {
        switch (level) {
            case megamenu_levels_enum_1.Levels.ONE:
                if (classNav !== megamenu_class_nav_enum_1.ClassNav.FIRST &&
                    id &&
                    currentId.indexOf(id) === constants_1.zero)
                    setClassNav(megamenu_class_nav_enum_1.ClassNav.FIRST);
                else
                    setClassNav(megamenu_class_nav_enum_1.ClassNav.SECOND);
                break;
            case megamenu_levels_enum_1.Levels.TWO:
                if (classNav !== megamenu_class_nav_enum_1.ClassNav.SECOND && currentId === id)
                    setClassNav(megamenu_class_nav_enum_1.ClassNav.SECOND);
                else
                    setClassNav(megamenu_class_nav_enum_1.ClassNav.THIRD);
                break;
            default:
                return '';
        }
    };
    const setMinHeight = (level, id, list) => {
        setTimeout(() => {
            const nav = navRef.current;
            const originHeight = nav.children.list.offsetHeight;
            const padding = nav.padding
                ? nav.padding
                : parseFloat(window.getComputedStyle(navRef.current).paddingTop);
            if (level === megamenu_levels_enum_1.Levels.ONE || currentId !== id) {
                const heightList = list.current.offsetHeight + padding * constants_1.two;
                nav.style.minHeight =
                    heightList > originHeight
                        ? `${heightList}px`
                        : `${originHeight}px`;
            }
            else {
                const previousList = list.current.parentElement.parentElement.offsetHeight +
                    padding * constants_1.two;
                nav.style.minHeight =
                    previousList > originHeight
                        ? `${previousList}px`
                        : `${originHeight}px`;
            }
        }, constants_1.zero);
    };
    return (React.createElement("div", { className: 'o-page-wrap  c-mega-menu__outer-wrap', "aria-labelledby": 'mega-menu-submenu' },
        React.createElement("div", { id: 'js-mega-menu', className: `js-mega-menu-wrap c-mega-menu__inner-wrap ${props.disabled ? '' : 'js-is-loaded'}` },
            React.createElement("nav", { id: 'nav-mega-menu', ref: navRef, className: `js-mega-menu c-mega-menu ${classNav}` },
                React.createElement("ul", { id: 'list', className: 'c-mega-menu__list c-mega-menu__list--level-one' },
                    props.menuLabel ? (React.createElement("li", { className: 'c-mega-menu__list-title' }, props.menuLabel)) : (''),
                    props.routes.map((route, index) => {
                        if (!route.allowedRoles ||
                            (props.userRole &&
                                route.allowedRoles.includes(props.userRole))) {
                            if (route.siblings) {
                                return (React.createElement(megamenu_dropdown_1.BronsonMegaMenuDropdown, { key: index, id: `${index}`, userRole: props.userRole, routes: route.siblings, menuLabel: route.label, img: route.img, onOpenMenu: onOpenSubMenu, onCloseMenu: props.onCloseMenu, level: megamenu_levels_enum_1.Levels.ONE, listLevel: megamenu_levels_enum_1.Levels.TWO, openLevels: openSubMenu, currentId: currentId }));
                            }
                            else {
                                return (React.createElement(megamenu_link_1.BronsonMegaMenuLink, { key: index, route: route, onCloseMenu: props.onCloseMenu }));
                            }
                        }
                    }))))));
};
exports.BronsonMegaMenu = BronsonMegaMenu;
